module.exports = __webpack_public_path__ + "static/media/hide_left.2e5e9445.svg";